if (!customElements.get('reevas-assistant-launcher')) {
  customElements.define(
    'reevas-assistant-launcher',
    class ReevasAssistantLauncher extends HTMLElement {
      static INSTANCE_ID = 'medcline_shopping_assistant';

      #listeners = new AbortController();

      connectedCallback() {
        const { signal } = this.#listeners;
        const input = this.querySelector('[data-reevas-assistant-input]');

        this.addEventListener(
          'click',
          (event) => {
            // A submit button fires 'submit' too — let that path own it.
            if (event.target.closest('button:not([type="submit"])')) this.open();
          },
          { signal }
        );

        this.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();
            this.open(input?.value);
            if (input) {
              input.value = '';
              this.#autoResize(input);
            }
          },
          { signal }
        );

        if (input) {
          input.addEventListener('input', () => this.#autoResize(input), { signal });
          input.addEventListener(
            'keydown',
            (event) => {
              if (event.key !== 'Enter' || event.shiftKey) return;
              event.preventDefault();
              this.querySelector('form')?.requestSubmit();
            },
            { signal }
          );
        }
        document.addEventListener('reevas:chat:ready', () => this.#api, { signal });
        this.#api; // warm the instance so it's ready on click
      }

      disconnectedCallback() {
        this.#listeners.abort();
        this.#listeners = new AbortController();
      }

      get #api() {
        const chat = window.Reevas?.chat;
        if (typeof chat?.getInstance !== 'function') return null;
        const existing = chat.getInstance(ReevasAssistantLauncher.INSTANCE_ID);
        if (existing || typeof chat.mount !== 'function') return existing ?? null;
        try {
          return chat.mount({
            instanceId: ReevasAssistantLauncher.INSTANCE_ID,
            apiBase: this.dataset.apiBase,
            domainKey: this.dataset.domainKey,
            shopDomain: this.dataset.shopDomain,
            profileKey: 'shopping_assistant',
            mode: 'modal',
          });
        } catch (error) {
          console.warn('[Reevas] Failed to mount shopping assistant instance.', error);
          return null;
        }
      }

      #autoResize(input) {
        input.style.height = '26px';
        input.style.height = `${input.scrollHeight}px`;
      }

      open(message = this.dataset.message) {
        const api = this.#api;
        if (typeof api?.openModal !== 'function' || api.isReady?.() === false) {
          document.addEventListener('reevas:chat:ready', () => this.open(message), { once: true });
          return;
        }

        // The assistant renders in the page, a <dialog> renders in the top layer — an open
        // dialog would cover it, so get out of the way first.
        this.closest('dialog')?.close();
        api.openModal(message?.trim() || undefined);
      }
    }
  );
}
